







































import { Component, Vue } from 'vue-property-decorator'
import SearchNav from '@/views/industryMall/shop/template/SearchNav.vue'
import ShopCard from '@/views/industryMall/shop/template/ShopCard.vue'
import SearchCategoryGoods from '@/views/industryMall/mallCategory/SearchCategoryGoods.vue'

import {
  addStoreSearchHistory,
  getCyStoreGoodsList,
  isGoodsValid,
  ShopGoodsInfoDto
} from '@/api/industryMall'
import { Getter } from 'vuex-class'

@Component({
  name: 'MallSearchShop',
  components: { SearchNav, ShopCard,SearchCategoryGoods }
})
export default class MallSearchShop extends Vue {
  @Getter companyId!: string
  @Getter partnerCompanyId!: string
  searchList = []

  refreshing = false
  loading = false
  finished = false

  params = {
    partnerCompanyId: '',
    keyword: '',
    pageSize: 20,
    pageIndex: 1
  }

  created() {
    console.log('34123124')

    this.params.keyword = this.$route.query.keyword as string
    this.params.partnerCompanyId = this.partnerCompanyId
    this.getList()
  }

  // 产业商城搜索历史记录管理（SM）
  addStoreSearchHistory() {
    // console.log('this', this.keyword, this.partnerCompanyId)
    const data = {
      searchType: 1,
      keyword: this.params.keyword,
      storeId: this.partnerCompanyId
    }
    addStoreSearchHistory({ ...data })
  }
  /**
   * 下拉刷新
   * */
  onRefresh() {
    this.params.pageIndex = 1
    this.refreshing = true
    this.getList()
  }
  // 刷新
  onLoad() {
    this.params.pageIndex++
    this.loading = true
    this.getList()
  }

  searchFunc(keyword: string) {
    console.log('keyword', keyword)
    this.params.keyword = keyword
    this.params.pageIndex = 1
    // this.getList()
    this.searchList = []
    this.getList()
  }
  getList() {
    let param = {
      ...this.params
      // partnerCompanyId: this.partnerCompanyId,
    }
    this.addStoreSearchHistory()
    getCyStoreGoodsList(param)
      .then((res) => {
        if (this.refreshing) {
          this.searchList = []
        }
        this.searchList = this.searchList.concat(res.data.records) || []
        if (this.searchList.length >= res.data.totalRecords) {
          this.finished = true
        }
      })
      .finally(() => {
        this.finished = true
        this.refreshing = false
        this.loading = false
      })
  }
  /**
   * 跳转商品详情
   */
  async toDetail(item: ShopGoodsInfoDto) {
    const val = await this.isGoodsValid(item)
    console.log('val-----', val)
    if (val) {
      this.$router.push({
        path: '/goodsMallDetail',
        query: {
          goodsId: item.goodsId,
          storeId: item.storeId
        }
      })
    } else {
      this.$dialog
        .alert({
          message: '商品过期不存在'
        })
        .then(() => {
          // this.getList()
          this.onRefresh()
        })
    }
  }
  // 商品是否存在
  isGoodsValid(item: ShopGoodsInfoDto) {
    const params = {
      shopId: item.storeId,
      goodsId: item.goodsId
    }
    return isGoodsValid(params)
      .then((res) => {
        if (res.data.isValid) {
          return true
        } else {
          return false
        }
      })
      .catch(() => {
        console.log('失败了')
        return false
      })
  }
}
